import { render, staticRenderFns } from "./DetalhesUsuario.vue?vue&type=template&id=541cf3a4&"
import script from "./DetalhesUsuario.vue?vue&type=script&lang=js&"
export * from "./DetalhesUsuario.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesUsuario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports